<div class="col-md-12" style="margin-left: -125px">
    <div class="tab-pane" role="tabpanel" id="formulario11">
        <fieldset id="agregar_formulario11" class="">
            <!-- <iframe frameBorder="0" id="sample-pdf" style="right:0; top:53px; bottom:0; height:400px; width:100%"></iframe> -->
            <div class="container" id="center_div">
                <div class="row">
                    <div class="col-md-12">

                        <div id='page1' class="contenedorFormulario print-wrap page1">
                            <div>
                                <span style="float: right; clear: right;">(S.O.M - 5.1.4 / 6.2.9)</span> Formulario 1.1
                                <span style="float: right; clear: right;">1/3</span>
                            </div>
                            <h1><strong>SOLICITUD DE PERMISO DE OBRA MENOR</strong></h1>
                            <br />
                            <div>
                                <table class="title">
                                    <tr>
                                        <td>
                                            <input disabled class="form-check-inline encab" type="checkbox" [checked]=" tipo_solicitud[0].optradio['AMPLIACIÓN MENOR A 100 M2']" name="optradio1" id="optradio" /><!---->
                                            <label for="optradio"> AMPLIACIÓN MENOR A 100 M2</label>
                                        </td>
                                        <td>
                                            <input disabled class="form-check-inline encab" type="checkbox" [checked]=" tipo_solicitud[0].optradio['MODIFICACIÓN']" name="optradio2" id="optradio" />
                                            <label for="optradio"> MODIFICACI&Oacute;N</label>
                                        </td>
                                        <td>
                                            <input disabled class="form-check-inline encab" type="checkbox" [checked]=" tipo_solicitud[0].optradio['ART 6 2 9 OGUC']" name="optradio3" id="optradio" />
                                            <label for="optradio"> ART 6.2.9. O.G.U.C.</label>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td></td>
                                        <td><label for="tipo_cert">sin alterar estructura</label></td>
                                        <td></td>
                                    </tr>
                                </table>
                            </div>
                            <div class="row">
                                <div class="col-md-4">
                                    &nbsp;
                                </div>
                                <div class="col-md-4">
                                    <h2 class="infObligatorios">
                                        <strong> DIRECCION DE OBRAS - MUNICIPALIDAD DE {{nombreMuni | uppercase}}</strong></h2>
                                    <h2 class="infObligatorios"> {{region}} </h2><!--{{region}}-->
                                    <table class="tablaConBorde">
                                        <tr>
                                            <td>
                                                <span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span>
                                                <span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span>
                                                <input disabled class="urb" type="checkbox" name="tpradio" id="tpradio" [checked]="propiedad[0].ubicacion == 'urbano'" />
                                                <label for="tpradio">URBANO</label>
                                                <span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span>
                                                <span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span>
                                                <span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span>
                                                <input disabled class="urb" type="checkbox" name="tpradio" id="tpradio" [checked]="propiedad[0].ubicacion == 'rural'" />
                                                <label for="tpradio">RURAL</label>
                                            </td>
                                        </tr>
                                    </table>
                                </div>
                                <div class="col-md-4">
                                    <table style="float: right; clear: right; width: 140px;" class="tablaConBorde table">
                                        <tbody>
                                            <tr>
                                                <td align="center" class="fondoResaltado">
                                                    N&Uacute;MERO SOLICITUD
                                                </td>
                                            </tr>
                                            <tr>
                                                <td align="center">
                                                    <input class="form-control" type="text" id="num_sol" value="" name="num_sol" disabled />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td align="center" class="fondoResaltado">
                                                    Fecha de Ingreso
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <input class="form-control" type="text" id="fecha_ingreso" value="" name="fecha_ingreso" disabled />
                                                </td>
                                            </tr>
                                        </tbody>
                                        <tfoot>
                                            <tr>
                                                <td class="letraChica">
                                                    * A LLENAR POR LA D.O.M
                                                </td>
                                            </tr>
                                        </tfoot>
                                    </table>
                                </div>
                            </div>
                            <br />
                            <div>
                                <table style="width: 100%;" class="tablaConBorde table">

                                    <tr class="rd_tipo">
                                        <td class="fondoResaltado izquierda" rowspan="2" style="width: 40%">
                                            CERTIFICADO DE INFORMACIONES PREVIAS:

                                        </td>
                                        <td class="fondoResaltado">
                                            N&uacute;mero
                                        </td>
                                        <td class="fondoResaltado">
                                            Fecha
                                        </td>

                                    </tr>
                                    <tr class="rd_tipo">
                                        <td>
                                            <input disabled class="form-control" type="text" name="certcip" id="certcip" [(ngModel)]="cip[0].certcip" />
                                        </td>
                                        <td>
                                            <input disabled class="form-control" type="text" name="fecha_cip" id="fecha_cip" [(ngModel)]="cip[0].fecha_cip" />
                                        </td>
                                    </tr>
                                </table>
                            </div>
                            <div>
                                <div class="tituloSeccion">
                                    <span> 1.- DIRECCI&Oacute;N DE LA PROPIEDAD</span>
                                    <span class="help-block"></span>
                                </div>
                                <table style="width: 100%" border="0" class="tablaConBorde table">
                                    <tr class="fondoResaltado">
                                        <td style="width: 57%" colspan="3">
                                            CALLE O CAMINO
                                        </td>
                                        <td style="width: 24%">
                                            N&Uacute;MERO
                                        </td>
                                        <td style="width: 19%">
                                            ROL SII
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colspan="3">
                                            <input disabled class="form-control" id="calle" name="calle" type="text" [(ngModel)]="propiedad[0].calle" />
                                        </td>
                                        <td>
                                            <input disabled class="form-control" id="numero" name="numero" type="text" [(ngModel)]="propiedad[0].calle_num" />
                                        </td>
                                        <td>
                                            <input disabled class="form-control" id="rol" name="rol" type="text" [(ngModel)]="propiedad[0].rol" />
                                        </td>

                                    </tr>
                                    <tr class="fondoResaltado">
                                        <td style="width: 11%">
                                            MANZANA
                                        </td>
                                        <td style="width: 10%">
                                            LOTE
                                        </td>
                                        <td style="width: 61%" colspan="2">
                                            LOTEO O LOCALIDAD
                                        </td>
                                        <td style="width: 18%">
                                            PLANO DE LOTEO N°
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <input disabled class="form-control" id="manzana" name="manzana" type="text" [(ngModel)]="propiedad[0].manzana" />
                                        </td>
                                        <td>
                                            <input disabled class="form-control" name="lote" id="lote" type="text" [(ngModel)]="propiedad[0].loteo" />
                                        </td>
                                        <td colspan="2">
                                            <input disabled class="form-control" id="localidad" name="localidad" type="text" [(ngModel)]="propiedad[0].localidad" />
                                        </td>
                                        <td>
                                            <input disabled class="form-control" id="loteo_numero" name="loteo_numero" type="text" [(ngModel)]="propiedad[0].plano" />
                                        </td>
                                    </tr>
                                </table>

                            </div>
                            <div>
                                <div class="tituloSeccion">
                                    <span>2.- DECLARACION JURADA</span>
                                    <span class="help-block"></span>
                                </div>

                                <table style="width: 100%;" class="tablaConBordeExterno table">
                                    <tr>
                                        <td colspan="7"><input disabled class="form-control" id="nombre" name="nombre" type="text" [(ngModel)]="propietarios[0].nombre" /></td>
                                        <td align="right" colspan="4"><span>C&Eacute;DULA DE</span></td>
                                    </tr>
                                    <tr>
                                        <td align="left"><span>IDENTIDAD Nº</span></td>
                                        <td colspan="5"><input disabled class="form-control" id="rut" name="rut" type="text" [(ngModel)]="propietarios[0].rut" /></td>
                                        <td colspan="5" align="right"><span>DECLARA BAJO SU RESPONSABILIDAD</span></td>
                                    </tr>
                                    <tr>
                                        <td align="left"><span> SER</span></td>
                                        <td align="left"><span>PROPIETARIO</span></td>
                                        <td colspan="3" align="center"><span>(O  REPRESENTANTE  LEGAL  DEL  PROPIETARIO)</span> </td>
                                        <td colspan="2"><span>DEL  BIEN  RAIZ</span></td>
                                        <td align="left" colspan="4"><span>UBICADO  EN  CALLE/ </span></td>
                                    </tr>
                                    <tr>
                                        <td align="left"><span>/AVENIDA/CAMINO</span></td>
                                        <td align="right" colspan="3"><input disabled class="form-control" id="calle" name="calle" type="text" [(ngModel)]="propietarios[0].direccion" /></td>
                                        <td align="left" colspan="3"><span>NUMERO:</span> </td>
                                        <td align="left" colspan="4"><input disabled class="form-control" id="numero" name="numero" type="text" [(ngModel)]="propietarios[0].direccion_num" /></td>
                                    </tr>
                                    <tr>
                                        <td align="left"><span>ROL DE AVALUO Nº</span></td>
                                        <td align="right" colspan="2"><input disabled class="form-control" id="rol" name="rol" type="text" [(ngModel)]="propiedad[0].rol" /></td>
                                        <td align="left"> <span>DE LA COMUNA DE </span></td>
                                        <td align="right" colspan="7"><input disabled class="form-control" id="comuna" name="comuna" [(ngModel)]="propietarios[0].comuna" type="text" /></td>
                                    </tr>
                                    <tr>
                                        <td colspan="2" align="left"><span>QUE SE ENCUENTRA INSCRITO A FOJAS</span></td>
                                        <td align="right"><input disabled class="form-control" id="inscripcion" name="inscripcion" type="text" [(ngModel)]="registro_bienes[0].inscrito" /></td>
                                        <td align="center"><span>N°</span></td>
                                        <td align="right" colspan="2"><input disabled class="form-control" id="num_insc" name="num_insc" type="text" [(ngModel)]="registro_bienes[0].numero" /></td>
                                        <td align="center"><span>AÑO</span></td>
                                        <td align="right"><input disabled class="form-control" id="anio_insc" name="anio_insc" type="text" [(ngModel)]="registro_bienes[0].anio" /></td>
                                        <td colspan="3" align="left"><span>DEL REGISTRO</span></td>
                                    </tr>
                                    <tr>
                                        <td align="left">DE PROPIEDAD</td>
                                        <td colspan="2" align="left"> DEL CONSERVADOR</td>
                                        <td align="left"> DE BIENES </td>
                                        <td align="left"> RAÍCES DE</td>
                                        <td align="left" colspan="6"><input disabled class="form-control" id="raices" name="raices" type="text" [(ngModel)]="registro_bienes[0].bienes" /></td>

                                    </tr>
                                    <tr>
                                        <td align="left">EN EL CUAL</td>
                                        <td align="left">SE EMPLAZA</td>
                                        <td colspan="2" align="left"><span>EL PROYECTO</span></td>
                                        <td align="left"><span>PARA EL QUE SE</span></td>
                                        <td colspan="6" align="left"><span>PRESENTA ESTA SOLICITUD</span></td>

                                    </tr>

                                </table>
                                <table class="tablaConBorde table">
                                    <tr>
                                        <td colspan="2" class="fondoResaltado izquierda" style="width: 40%;" align="left"><span>ADJUNTA PLANO TOPOGRAFICO (*)</span><span class="letraChica"> ART 1.4.8 OGUC</span></td>
                                        <td style="width: 5%; " align="center"><span><input disabled class="form-check-inline" type="checkbox" name="plano" id="plano"  [checked]="declaracion[0].plano == 'SI'"/>SI</span></td>
                                        <td style="width: 5%; " align="center"><span><input disabled class="form-check-inline" type="checkbox" name="plano" id="plano"  [checked]="declaracion[0].plano == 'NO'"/>NO</span></td>
                                        <td colspan="2" class="fondoResaltado" style="width: 50%; " align="left"><span></span></td>
                                    </tr>
                                    <tr>
                                        <td style="width: 20%; " align="left" class="fondoResaltado izquierda"><span>DENOMINADO: </span></td>
                                        <td colspan="5"><span><input disabled class="form-control" id="denominado" name="denominado" type="text" [(ngModel)]="declaracion[0].denominado"/></span></td>

                                    </tr>
                                    <tr>
                                        <td style="width: 20%; " align="left" class="fondoResaltado izquierda"><span>ELABORADO</span></td>
                                        <td colspan="3"><span><input disabled class="form-control" id="elaborado" name="elaborado" type="text" [(ngModel)]="declaracion[0].elaborado"/></span></td>
                                        <td style="width: 20%; " align="left" class="fondoResaltado izquierda"><span>DE PROFESION</span></td>
                                        <td><span><input disabled class="form-control" id="profesion" name="profesion" type="text" [(ngModel)]="declaracion[0].profesion" /></span></td>
                                    </tr>
                                </table>
                                <div class="letraChica"><span>NOTA: DE EXISTIR DOS O MÁS PROPIETARIOS, Y/O DOS O MÁS BIENES RAÍCES SE DEBERÁ ACOMPAÑAR HOJA ADJUNTA CON LOS DATOS Y FIRMAS CORRESPONDIENTE (*) SOLO EN LA EVENTUALIDAD QUE SE ACOMPAÑE DICHO PLANO.</span></div>

                            </div>
                            <div>
                                <div class="tituloSeccion">
                                    <span>3.- DATOS DEL PROPIETARIO</span>
                                    <span class="help-block"></span>
                                </div>
                                <table class="tablaConBorde table form-group clone1">
                                    <tr class="fondoResaltado">
                                        <td colspan="2" style="width: 65%">
                                            NOMBRE DEL PROPIETARIO
                                        </td>
                                        <td>
                                            R.U.T.
                                        </td>
                                        <td>
                                            FIRMA DEL PROPIETARIO
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colspan="2">
                                            <input disabled class="form-control" readonly id="nombre_prop" name="nombre_prop" type="text" [(ngModel)]="propietarios[0].nombre" />
                                        </td>
                                        <td>
                                            <input disabled class="form-control" id="rut_prop" name="rut_prop" type="text" [(ngModel)]="propietarios[0].rut" />
                                        </td>
                                        <td rowspan="7">

                                        </td>

                                    </tr>
                                    <tr class="fondoResaltado">
                                        <td colspan="2" style="width: 65%">
                                            REPRESENTANTE LEGAL
                                        </td>
                                        <td>
                                            R.U.T.
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colspan="2"><input disabled class="form-control" readonly id="nombre_rep" name="nombre_rep" type="text" [(ngModel)]="representantes[0].nombre" /></td>
                                        <td><input disabled class="form-control" id="rut_rep" name="rut_rep" type="text" [(ngModel)]="representantes[0].rut" /></td>
                                    </tr>

                                    <tr class="fondoResaltado">
                                        <td style="width: 25%">
                                            DIRECCI&Oacute;N / CALLE / PASAJE
                                        </td>
                                        <td style="width: 25%">
                                            N°
                                        </td>
                                        <td style="width: 25%">
                                            COMUNA
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style="width: 25%">
                                            <input disabled class="form-control" id="direccion" name="direccion" type="text" [(ngModel)]="propietarios[0].direccion" />
                                        </td>
                                        <td style="width: 25%">
                                            <input disabled class="form-control" id="num" name="num" type="text" [(ngModel)]="propietarios[0].direccion_num" />
                                        </td>
                                        <td style="width: 25%">
                                            <input disabled class="form-control" id="comuna" name="comuna" type="text" [(ngModel)]="propietarios[0].comuna" />
                                        </td>
                                    </tr>
                                    <tr class="fondoResaltado">
                                        <td>
                                            E-MAIL
                                        </td>
                                        <td>
                                            TEL&Eacute;FONO
                                        </td>
                                        <td>
                                            FAX
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <input disabled class="form-control" id="email_prop" name="email_prop" type="email" [(ngModel)]="propietarios[0].mail" />
                                        </td>
                                        <td>
                                            <input disabled class="form-control" id="tel_prop" name="tel_prop" type="text" [(ngModel)]="propietarios[0].fono" />
                                        </td>
                                        <td>
                                            <input disabled class="form-control" id="fax_prop" name="fax_prop" type="text" [(ngModel)]="propietarios[0].fax" />
                                        </td>
                                    </tr>
                                    <tr class="fondoResaltado tablaConBordeExterno table">
                                        <td colspan="4">
                                            PERSONERIA DEL REPRESENTANTE LEGAL
                                        </td>

                                    </tr>
                                    <tr>
                                        <td>
                                            SE ACREDITA MEDIANTE
                                        </td>
                                        <td colspan="3">
                                            <input disabled class="form-control" id="acredita" name="acredita" type="text" [(ngModel)]="permiso_notariado[0].acreditacion" />
                                        </td>

                                    </tr>
                                    <tr>
                                        <td>
                                            DE FECHA
                                        </td>
                                        <td>
                                            <input disabled class="form-control" id="fecha_acr" name="fecha_acr" type="text" [(ngModel)]="permiso_notariado[0].fecha" />
                                        </td>
                                        <td>
                                            Y REDUCIDA A ESCRITURA PUBLICA CON FECHA
                                        </td>
                                        <td>
                                            <input disabled class="form-control" id="fecha_esc" name="fecha_esc" type="text" [(ngModel)]="permiso_notariado[0].escritura" />
                                        </td>

                                    </tr>
                                    <tr>
                                        <td>
                                            ANTE EL NOTARIO SR(A)
                                        </td>
                                        <td colspan="3">
                                            <input disabled class="form-control" id="notario" name="notario" type="text" [(ngModel)]="permiso_notariado[0].notario" />
                                        </td>
                                    </tr>
                                </table>
                            </div>
                            <div>
                                <div class="tituloSeccion">
                                    <span>4.- ARQUITECTO PROYECTISTA</span>
                                    <span class="help-block"></span>
                                </div>
                                <table class="tablaConBorde table form-group clone1">
                                    <tr class="fondoResaltado">
                                        <td colspan="2" style="width: 65%"><span>
                                        NOMBRE O RAZON SOCIAL DE LA EMPRESA</span><span class="letraChica">(cuando corresponda)</span>
                                        </td>
                                        <td>
                                            R.U.T.
                                        </td>
                                        <td>
                                            FIRMA
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colspan="2">
                                            <input disabled class="form-control" readonly id="nombre_emp" name="nombre_emp" type="text" [(ngModel)]="empresas[0].nombre" />
                                        </td>
                                        <td>
                                            <input disabled class="form-control" id="rut_emp" name="rut_emp" type="text" [(ngModel)]="empresas[0].rut" />
                                        </td>
                                        <td rowspan="5"></td>

                                    </tr>
                                    <tr class="fondoResaltado">
                                        <td colspan="2" style="width: 65%">
                                            NOMBRE ARQUITECTO PROYECTISTA
                                        </td>
                                        <td>
                                            R.U.T.
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colspan="2"><input disabled class="form-control" readonly id="nombre_arq" name="nombre_arq" type="text" [(ngModel)]="arquitectos[0].nombre" /></td>
                                        <td><input disabled class="form-control" id="rut_arq" name="rut_arq" type="text" [(ngModel)]="arquitectos[0].rut" /></td>
                                    </tr>

                                    <tr class="fondoResaltado">
                                        <td style="width: 25%">
                                            DIRECCI&Oacute;N / CALLE / PASAJE
                                        </td>
                                        <td style="width: 25%">
                                            N°
                                        </td>
                                        <td style="width: 25%">
                                            COMUNA
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style="width: 25%">
                                            <input disabled class="form-control" id="direccion" name="direccion" type="text" [(ngModel)]="arquitectos[0].direccion" />
                                        </td>
                                        <td style="width: 25%">
                                            <input disabled class="form-control" id="num" name="num" type="text" [(ngModel)]="arquitectos[0].direccion_num" />
                                        </td>
                                        <td style="width: 25%">
                                            <input disabled class="form-control" id="comuna" name="comuna" type="text" [(ngModel)]="arquitectos[0].comuna" />
                                        </td>
                                    </tr>
                                    <tr class="fondoResaltado">
                                        <td>
                                            E-MAIL
                                        </td>
                                        <td>
                                            TEL&Eacute;FONO
                                        </td>
                                        <td>
                                            FAX
                                        </td>
                                        <td>
                                            PATENTE PROFESIONAL N°
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <input disabled class="form-control" id="email_arq" name="email_arq" type="email" [(ngModel)]="arquitectos[0].mail" />
                                        </td>
                                        <td>
                                            <input disabled class="form-control" id="tel_arq" name="tel_arq" type="text" [(ngModel)]="arquitectos[0].fono" />
                                        </td>
                                        <td>
                                            <input disabled class="form-control" id="fax_arq" name="fax_arq" type="text" [(ngModel)]="arquitectos[0].fax" />
                                        </td>
                                        <td>
                                            <input disabled class="form-control" id="pat_arq" name="pat_arq" type="text" [(ngModel)]="arquitectos[0].patente" />
                                        </td>
                                    </tr>
                                </table>
                            </div>
                            <br />
                            <br />
                            <br />
                            <br />
                        </div>
                        <div id='page2' class="contenedorFormulario print-wrap page2">
                            <div>
                                <span style="float: right; clear: right;">(S.O.M - 5.1.4 / 6.2.9)</span> Formulario 1.1
                                <span style="float: right; clear: right;">2/3</span>
                            </div>
                            <br />
                            <div>

                                <table class="tablaConBorde table form-group">
                                    <tr class="fondoResaltado">
                                        <td colspan="2" style="width: 65%"><span>
                                            NOMBRE O RAZON SOCIAL DE LA EMPRESA CONSTRUCTORA</span>
                                        </td>
                                        <td>
                                            R.U.T.
                                        </td>
                                        <td>
                                            FIRMA
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colspan="2">
                                            <input disabled class="form-control" readonly id="nombre_constra" name="nombre_constra" type="text" [(ngModel)]="constructora[0].nombre" />
                                        </td>
                                        <td>
                                            <input disabled class="form-control" id="rut_constra" name="rut_constra" type="text" [(ngModel)]="constructora[0].rut" />
                                        </td>
                                        <td rowspan="5"></td>

                                    </tr>
                                    <tr class="fondoResaltado">
                                        <td colspan="2" style="width: 65%">
                                            NOMBRE DEL CONSTRUCTOR *
                                        </td>
                                        <td>
                                            R.U.T.
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colspan="2"><input disabled class="form-control" readonly id="nombre_const" name="nombre_const" type="text" [(ngModel)]="constructores[0].nombre" /></td>
                                        <td><input disabled class="form-control" id="rut_const" name="rut_const" type="text" [(ngModel)]="constructores[0].rut" /></td>
                                    </tr>

                                    <tr class="fondoResaltado">
                                        <td style="width: 25%">
                                            DIRECCI&Oacute;N / CALLE / PASAJE
                                        </td>
                                        <td style="width: 25%">
                                            N°
                                        </td>
                                        <td style="width: 25%">
                                            COMUNA
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style="width: 25%">
                                            <input disabled class="form-control" id="direccion" name="direccion" type="text" [(ngModel)]="constructores[0].direccion" />
                                        </td>
                                        <td style="width: 25%">
                                            <input disabled class="form-control" id="num" name="num" type="text" [(ngModel)]="constructores[0].direccion_num" />
                                        </td>
                                        <td style="width: 25%">
                                            <input disabled class="form-control" id="comuna" name="comuna" type="text" [(ngModel)]="constructores[0].comuna" />
                                        </td>
                                    </tr>
                                    <tr class="fondoResaltado">
                                        <td>
                                            E-MAIL
                                        </td>
                                        <td>
                                            TEL&Eacute;FONO
                                        </td>
                                        <td>
                                            FAX
                                        </td>
                                        <td>
                                            PATENTE PROFESIONAL N°
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <input disabled class="form-control" id="email_const" name="email_const" type="email" [(ngModel)]="constructores[0].mail" />
                                        </td>
                                        <td>
                                            <input disabled class="form-control" id="tel_const" name="tel_const" type="text" [(ngModel)]="constructores[0].fono" />
                                        </td>
                                        <td>
                                            <input disabled class="form-control" id="fax_const" name="fax_const" type="text" [(ngModel)]="constructores[0].fax" />
                                        </td>
                                        <td>
                                            <input disabled class="form-control" id="pat_const" name="pat_const" type="text" [(ngModel)]="constructora[0].patente" />
                                        </td>
                                    </tr>
                                </table>
                                <div class="letraChica"><span>* Profesional que podr&aacute; individualizarse hasta antes del inicio de las obras</span></div>
                            </div>
                            <div>
                                <div class="tituloSeccion">
                                    <span>5.- REVISOR INDEPENDIENTE</span>
                                    <span class="help-block"></span>
                                </div>
                                <table class="tablaConBorde table form-group">
                                    <tr>
                                        <td colspan="3" class="fondoResaltado izquierda"><span>
                                           CUENTA CON INFORME FAVORABLE REVISOR INDEPENDIENTE</span>
                                        </td>
                                        <td align="center"><input type="checkbox" disabled class="form-check-inline" readonly id="informe" name="informe" value="SI" [checked]="informe[0].infradio == 'SI'" /><span>SI</span></td>
                                        <td align="center"><input type="checkbox" disabled class="form-check-inline" readonly id="informe" name="informe" value="NO" [checked]="informe[0].infradio == 'NO'" /><span>NO</span></td>
                                        <td colspan="2"><span>N°</span></td>
                                        <td><span><input disabled class="form-control" readonly id="numero" name="numero" type="text" [(ngModel)]="informe[0].num_informe"/></span></td>
                                        <td colspan="2"><span>Fecha</span></td>
                                        <td><span><input disabled class="form-control" readonly id="fecha" name="fecha" type="text" [(ngModel)]="informe[0].fech_informe"/></span></td>
                                    </tr>
                                    <tr>
                                        <td class="fondoResaltado" colspan="12"><span>NOMBRE REVISOR INDEPENDIENTE</span></td>
                                    </tr>
                                    <tr>
                                        <td colspan="12">
                                            <input disabled class="form-control" id="nombre_ind" name="nombre_ind" type="text" [(ngModel)]="independiente[0].nombre" />
                                        </td>
                                    </tr>
                                    <tr class="fondoResaltado">
                                        <td colspan="2">R.U.T.</td>
                                        <td colspan="3">EMAIL</td>
                                        <td colspan="3">TELEFONO / FAX</td>
                                        <td colspan="2">CATEGORIA</td>
                                        <td colspan="2">REGISTRO</td>
                                    </tr>
                                    <tr>
                                        <td colspan="2"><input disabled class="form-control" readonly id="rut_ind" name="rut_ind" type="text" [(ngModel)]="independiente[0].rut" /></td>
                                        <td colspan="3"><input disabled class="form-control" readonly id="email_ind" name="email_ind" type="text" [(ngModel)]="independiente[0].mail" /></td>
                                        <td colspan="3"><input disabled class="form-control" readonly id="telf_ind" name="telf_ind" type="text" [(ngModel)]="independiente[0].fono" /></td>
                                        <td colspan="2"><input disabled class="form-control" readonly id="cat_ind" name="cat_ind" type="text" [(ngModel)]="independiente[0].categoria" /></td>
                                        <td colspan="2"><input disabled class="form-control" readonly id="reg_ind" name="reg_ind" type="text" [(ngModel)]="independiente[0].registro" /></td>
                                    </tr>
                                </table>
                            </div>
                            <div>
                                <div class="tituloSeccion">
                                    <span>6.- ANTECEDENTES DE PERMISOS Y RECEPCIONES ANTERIORES</span>
                                    <span class="help-block"></span>
                                </div>
                                <table class="tablaConBorde table form-group">
                                    <tr class="fondoResaltado">
                                        <td style="width: 25%">PERMISO PRIMITIVO</td>
                                        <td style="width: 25%">N°</td>
                                        <td style="width: 25%">FECHA</td>
                                        <td style="width: 25%">SUPERFICIE M2</td>
                                    </tr>
                                    <tr *ngFor="let prim of perm_pri">
                                        <td><input disabled class="form-control" readonly id="permiso_prim" name="permiso_prim" type="text" [(ngModel)]="prim.permiso" /></td>
                                        <td><input disabled class="form-control" readonly id="permiso_num" name="permiso_num" type="text" [(ngModel)]="prim.numero" /></td>
                                        <td><input disabled class="form-control" readonly id="permiso_fecha" name="permiso_fecha" type="text" [(ngModel)]="prim.fecha" /></td>
                                        <td><input disabled class="form-control" readonly id="superficie" name="superficie" type="text" [(ngModel)]="prim.superficie" /></td>
                                    </tr>
                                </table>
                                <br />
                                <table class="tablaConBorde table form-group">
                                    <tr class="fondoResaltado">
                                        <td style="width: 25%">MODIFICACIONES Y AMPLIACIONES</td>
                                        <td style="width: 25%">N°</td>
                                        <td style="width: 25%">FECHA</td>
                                        <td style="width: 25%">SUPERFICIE M2</td>
                                    </tr>
                                    <tr *ngFor="let ampl of ampliaciones">
                                        <td><input disabled class="form-control" readonly id="modif_prim1" name="modif_prim1" type="text" [(ngModel)]="ampl.permiso" /></td>
                                        <td><input disabled class="form-control" readonly id="modif_num1" name="modif_num1" type="text" [(ngModel)]="ampl.numero" /></td>
                                        <td><input disabled class="form-control" readonly id="modif_fecha1" name="modif_fecha1" type="text" [(ngModel)]="ampl.fecha" /></td>
                                        <td><input disabled class="form-control" readonly id="modif_sup1" name="modif_sup1" type="text" [(ngModel)]="ampl.superficie" /></td>
                                    </tr>
                                </table>
                                <br />
                                <table class="tablaConBorde table form-group">
                                    <tr class="fondoResaltado">
                                        <td style="width: 25%">RECEPCION</td>
                                        <td style="width: 25%">N°</td>
                                        <td style="width: 25%">FECHA</td>
                                        <td style="width: 25%">SUPERFICIE M2</td>
                                    </tr>
                                    <tr *ngFor="let rec of recep">
                                        <td><input disabled class="form-control" readonly id="recep_prim1" name="recep_prim1" type="text" [(ngModel)]="rec.permiso" /></td>
                                        <td><input disabled class="form-control" readonly id="recep_num1" name="recep_num1" type="text" [(ngModel)]="rec.numero" /></td>
                                        <td><input disabled class="form-control" readonly id="recep_fecha1" name="recep_fecha1" type="text" [(ngModel)]="rec.fecha" /></td>
                                        <td><input disabled class="form-control" readonly id="recep_sup1" name="recep_sup1" type="text" [(ngModel)]="rec.superficie" /></td>
                                    </tr>
                                </table>

                            </div>
                            <div>
                                <div class="tituloSeccion">
                                    <span>7.- CARACTERISTICAS DEL PROYECTO (PARA PROYECTOS DE EDIFICACIÓN)</span>
                                    <span class="help-block"></span>
                                </div>
                                <table class="tablaConBorde table form-group">
                                    <tr class="fondoResaltado">
                                        <td colspan="2">DESTINO PRINCIPAL DE LA EDIFICACIÓN</td>
                                        <td>SUP. TOTAL EXISTENTE</td>
                                        <td>SUP. TOTAL PROYECTADA</td>
                                        <td>N° PISOS SOBRE N.N.T</td>
                                    </tr>
                                    <tr>
                                        <td colspan="2"><input disabled class="form-control" readonly id="destino1" name="destino1" type="text" [(ngModel)]="proyecto[0].destinos" /></td>
                                        <td><input disabled class="form-control" readonly id="suptotal1" name="suptotal1" type="text" [(ngModel)]="proyecto[0].superf_existente" /></td>
                                        <td><input disabled class="form-control" readonly id="supproy1" name="supproy1" type="text" [(ngModel)]="proyecto[0].superf_proyectada" /></td>
                                        <td><input disabled class="form-control" readonly id="npisos1" name="npisos1" type="text" [(ngModel)]="proyecto[0].npisos" /></td>
                                    </tr>
                                    <tr>
                                        <td colspan="2"><input disabled class="form-control" readonly id="destino2" name="destino2" type="text" [(ngModel)]="proyecto[0].destinos" /></td>
                                        <td><input disabled class="form-control" readonly id="suptotal2" name="suptotal2" type="text" [(ngModel)]="proyecto[0].superf_existente" /></td>
                                        <td><input disabled class="form-control" readonly id="supproy2" name="supproy2" type="text" [(ngModel)]="proyecto[0].superf_proyectada" /></td>
                                        <td><input disabled class="form-control" readonly id="npisos2" name="npisos2" type="text" [(ngModel)]="proyecto[0].npisos" /></td>
                                    </tr>
                                    <tr>
                                        <td class="fondoResaltado">SUPERFICIE TOTAL TERRENO</td>
                                        <td class="fondoResaltado">COEF. CONSTRUCTIBILIDAD</td>
                                        <td><input disabled class="form-control" readonly id="coef" name="coef" type="text" [(ngModel)]="proyecto[0].coef_construct" /></td>
                                        <td class="fondoResaltado">COEF. DE OCUPACION DE SUELO</td>
                                        <td><input disabled class="form-control" readonly id="ocup" name="ocup" type="text" [(ngModel)]="proyecto[0].coef_ocupacion" /></td>
                                    </tr>
                                    <tr>
                                        <td rowspan="2"><input disabled class="form-control" readonly id="sup_terreno" name="sup_terreno" type="text" [(ngModel)]="proyecto[0].superf_terreno" /></td>
                                        <td class="fondoResaltado">OCUPADO</td>
                                        <td><input disabled class="form-control" readonly id="ocup" name="ocup" type="text" [(ngModel)]="proyecto[0].ocupadoc" /></td>
                                        <td class="fondoResaltado">PROYECTADO</td>

                                        <td><input disabled class="form-control" readonly id="proy" name="proy" type="text" [(ngModel)]="proyecto[0].proyectadoc" /></td>
                                    </tr>
                                    <tr>

                                        <td class="fondoResaltado">OCUPADO</td>
                                        <td><input disabled class="form-control" readonly id="ocup" name="ocup" type="text" [(ngModel)]="proyecto[0].ocupadooc" /></td>
                                        <td class="fondoResaltado">PROYECTADO</td>
                                        <td><input disabled class="form-control" readonly id="proy" name="proy" type="text" [(ngModel)]="proyecto[0].proyectadooc" /></td>
                                    </tr>
                                </table>
                                <br />
                                <table class="tablaConBorde table form-group">
                                    <tr>
                                        <td colspan="12" class="fondoResaltado">AUTORIZACIONES ESPECIALES</td>
                                    </tr>
                                    <tr>
                                        <td align="center"><input type="checkbox" disabled class="form-check-inline" readonly id="autorizaciones" name="autorizaciones" value="ART 121 LGUC" [(ngModel)]="proyecto[0].Art121" /></td>
                                        <td><span>ART 121 LGUC</span></td>
                                        <td align="center"><input type="checkbox" disabled class="form-check-inline" readonly id="autorizaciones" name="autorizaciones" value="ART 122 LGUC" [(ngModel)]="proyecto[0].Art122" /></td>
                                        <td><span>ART 122 LGUC</span></td>
                                        <td align="center"><input type="checkbox" disabled class="form-check-inline" readonly id="autorizaciones" name="autorizaciones" value="ART 123 LGUC" [(ngModel)]="proyecto[0].Art123" /></td>
                                        <td><span>ART 123 LGUC</span></td>
                                        <td align="center"><input type="checkbox" disabled class="form-check-inline" readonly id="autorizaciones" name="autorizaciones" value="ART 124 LGUC" [(ngModel)]="proyecto[0].Art124" /></td>
                                        <td><span>ART 124 LGUC</span></td>
                                        <td align="center"><input type="checkbox" disabled class="form-check-inline" readonly id="autorizaciones" name="autorizaciones" value="LEY 19537" [(ngModel)]="proyecto[0].Ley19537" /></td>
                                        <td><span>LEY 19537</span></td>
                                        <td align="center"><input type="checkbox" disabled class="form-check-inline" readonly id="autorizaciones" name="autorizaciones" value="OTRO" [(ngModel)]="proyecto[0].Otro" /></td>
                                        <td><span>OTRO</span></td>
                                    </tr>
                                </table>
                                <br />
                                <table class="tablaConBorde table form-group">
                                    <tr>
                                        <td colspan="8" class="fondoResaltado izquierda">AUTORIZACIONES ESPECIALES</td>
                                        <td align="center"><input type="checkbox" disabled class="form-check-inline" readonly id="uso_pub" name="uso_pub" value="SI" [checked]="proyecto[0].uso_publico == 'SI'" />
                                            <span>SI</span></td>
                                        <td align="center"><input type="checkbox" disabled class="form-check-inline" readonly id="uso_pub" name="uso_pub" value="NO" [checked]="proyecto[0].uso_publico == 'NO'" />
                                            <span>NO</span></td>
                                    </tr>
                                    <tr>
                                        <td colspan="8" class="fondoResaltado izquierda">EDIFICIO DECLARADO MONUMENTO NACIONAL O SEÑALADO COMO INMUEBLE O ZONA DE CONSERVACION HISTORICA POR EL IPT</td>
                                        <td align="center"><input type="checkbox" disabled class="form-check-inline" readonly id="mon_nac" name="mon_nac" value="SI" [checked]="proyecto[0].edif_nac == 'SI'" />
                                            <span>SI</span></td>
                                        <td align="center"><input type="checkbox" disabled class="form-check-inline" readonly id="mon_nac" name="mon_nac" value="NO" [checked]="proyecto[0].edif_nac == 'NO'" />
                                            <span>NO</span></td>
                                    </tr>
                                </table>

                            </div>
                            <div>
                                <div class="tituloSeccion">
                                    <span>8.- PLAZO SOLICITADO</span><span class="letraChica">(En caso de Articulos 121,122,123,124 de la LGUC)</span>
                                    <span class="help-block"></span>
                                </div>
                                <div><span>Se solicita que el permiso tenga una vigencia de </span><span><input disabled readonly id="anio" name="anio" type="text" [(ngModel)]="plazo[0].plazo"/></span> años<span></span></div>
                            </div>
                            <div>
                                <div class="tituloSeccion">
                                    <span>9.- ANTECEDENTES QUE SE ADJUNTAN</span>
                                    <span class="help-block"></span>
                                    <span class="letraChica">(ART. 5.1.4/1.4.2/1.2.1. OGUC)</span>
                                </div>

                                <table class="tablaConBorde table form-group">
                                    <tr class="fondoResaltado">
                                        <td style="width: 10%">DOM</td>
                                        <td colspan="2"></td>
                                        <td style="width: 10%">DOM</td>
                                        <td colspan="2"></td>
                                    </tr>
                                    <tr>
                                        <td style="width: 10%"></td>
                                        <td align="center"><input type="checkbox"  class="form-check-inline" id="documentos" name="documentos" checked disabled/></td>
                                        <td><span>Fotocopia Certificado de Informaciones Previas Vigente</span></td>
                                        <td style="width: 10%"></td>
                                        <td align="center"><input type="checkbox" class="form-check-inline" id="documentos" name="documentos" checked disabled/></td>
                                        <td><span>Fotocopia de Patente al dia del o los Profesional (es)Competente(s)</span></td>
                                    </tr>
                                    <tr>
                                        <td style="width: 10%"></td>
                                        <td align="center"><input type="checkbox" class="form-check-inline" id="documentos" name="documentos" (change)="check_event($event)" value="Declaracion Simple del Profesional Competente, segun corresponda"/></td>
                                        <td><span>Declaracion Simple del Profesional Competente, segun corresponda</span></td>
                                        <td style="width: 10%"></td>
                                        <td align="center"><input type="checkbox" class="form-check-inline" id="documentos" name="documentos" checked disabled/></td>
                                        <td><span>Croquis de ubicacion o croquis de emplazamiento, a escala.</span></td>
                                    </tr>
                                    <tr>
                                        <td style="width: 10%"></td>
                                        <td align="center"><input type="checkbox" class="form-check-inline" id="documentos" name="documentos" (change)="check_event($event)" value="Informe del Revisor Independiente (Si ocurre)"/></td>
                                        <td><span>Informe del Revisor Independiente (Si ocurre)</span></td>
                                        <td style="width: 10%"></td>
                                        <td align="center"><input type="checkbox" class="form-check-inline" id="documentos" name="documentos" (change)="check_event($event)" value="Plano a escala y cuadro de superficie, cuando corresponda."/></td>
                                        <td><span>Plano a escala y cuadro de superficie, cuando corresponda.</span></td>
                                    </tr>
                                    <tr>
                                        <td style="width: 10%"></td>
                                        <td align="center"><input type="checkbox" class="form-check-inline" id="documentos" name="documentos" (change)="check_event($event)" value="Certificado de Inscripcion Revisor Independiente, cuando corresponde"/></td>
                                        <td><span>Certificado de Inscripcion Revisor Independiente, cuando corresponde</span></td>
                                        <td style="width: 10%"></td>
                                        <td align="center"><input type="checkbox" class="form-check-inline" id="documentos" name="documentos" (change)="check_event($event)" value="Especificaciones Tecnicas resumidas, cuando corresponda."/></td>
                                        <td><span>Especificaciones Tecnicas resumidas, cuando corresponda.</span></td>
                                    </tr>
                                </table>


                            </div>
                            <div>
                                <div class="tituloSeccion">
                                    <span>10.- MONTO A CONSIGNAR AL INGRESO </span><span class="letraChica"> (A LLENAR POR LA D.O.M)</span>
                                    <span class="help-block"></span>
                                </div>

                                <table class="tablaConBorde table form-group">
                                    <tr>
                                        <td>PRESUPUESTO DE OBRA</td>
                                        <td> <input disabled class="form-control" readonly id="presupuesto" name="presupuesto" type="text" value="$" /></td>
                                        <td>MONTO TOTAL DE DERECHOS MUNICIPALES</td>
                                        <td> <input disabled class="form-control" readonly id="monto" name="monto" type="text" value="$" /></td>
                                    </tr>
                                    <tr>
                                        <td>PORCENTAJE A CONSIGNAR</td>
                                        <td align="right"><input disabled class="form-control" readonly id="giro" name="giro" type="text" value="%" /></td>
                                        <td>MONTO</td>
                                        <td><input disabled class="form-control" readonly id="giro" name="giro" type="text" value="$" /></td>
                                    </tr>
                                    <tr>
                                        <td>GIRO INGRESO MUNICIPAL N°</td>
                                        <td><input disabled class="form-control" readonly id="giro" name="giro" type="text" /></td>
                                        <td>DE FECHA</td>
                                        <td><input disabled class="form-control" readonly id="fecha" name="fecha" type="text" /></td>
                                    </tr>
                                </table>
                                <br />
                                <br />
                                <br />
                                <br />
                            </div>
                        </div>
                        <div id='page3' class="contenedorFormulario print-wrap page3">
                            <div>
                                <span style="float: right; clear: right;">(S.O.M - 5.1.4 / 6.2.9)</span> Formulario 1.1
                                <span style="float: right; clear: right;">3/3</span>
                            </div>
                            <br />
                            <div class="tablaConBordeExterno">
                                <span>NOTA </span><span class="letraChica">( PARA SITUACIONES ESPECIALES )</span>
                                <span><input disabled class="form-control" readonly id="nota" name="nota" type="textarea" /></span>
                            </div>
                            <div>
                                <br />
                                <br />
                                <br />
                                <hr />
                                <br />
                                <br />
                            </div>
                            <div>
                                <div><span style="float: right; clear: right;">(S.O.M - 5.1.4 / 6.2.9)</span></div>
                                <div>
                                    <h1><strong>COMPROBANTE DE INGRESO</strong></h1>
                                </div>
                            </div>
                            <br />
                            <br />
                            <div>
                                <table class="tablaConBorde izquierda">
                                    <tr>
                                        <td class="fondoResaltado">MONTO CONSIGNADO AL INGRESO</td>
                                        <td><input disabled class="form-control" readonly id="monto" name="monto" type="text" value="$" /></td>
                                        <td class="fondoResaltado">GIM N°</td>
                                        <td><input disabled class="form-control" readonly id="gim" name="gim" type="text" /></td>
                                        <td class="fondoResaltado">FECHA</td>
                                        <td><input disabled class="form-control" readonly id="fecha" name="fecha" type="text" /></td>
                                    </tr>
                                </table>
                            </div>
                            <br />
                            <div class="row">
                                <div class="col-md-4">
                                    <table class="tablaConBordeExterno">
                                        <tr>
                                            <td>&nbsp;</td>
                                        </tr>
                                        <tr>
                                            <td>&nbsp;</td>
                                        </tr>
                                        <tr>
                                            <td>&nbsp;</td>
                                        </tr>
                                        <tr>
                                            <td>&nbsp;</td>
                                        </tr>
                                        <tr>
                                            <td>&nbsp;</td>
                                        </tr>
                                        <tr>
                                            <td>&nbsp;</td>
                                        </tr>
                                        <tr align="center">
                                            <td>FIRMA FUNCIONARIO.</td>
                                        </tr>
                                        <tr align="center">
                                            <td> Y TIMBRE D.O.M.</td>
                                        </tr>
                                    </table>
                                </div>
                                <br />
                                <div class="col-md-4">
                                    <h2 class="infObligatorios">
                                        <strong> DIRECCION DE OBRAS - MUNICIPALIDAD DE {{nombreMuni | uppercase}}</strong></h2>
                                    <h2 class="infObligatorios"> {{region}} </h2>
                                </div>
                                <div class="col-md-4">
                                    <table style="float: right; clear: right; width: 140px;" class="tablaConBorde table">
                                        <tbody>
                                            <tr>
                                                <td align="center" class="fondoResaltado">
                                                    N&Uacute;MERO SOLICITUD
                                                </td>
                                            </tr>
                                            <tr>
                                                <td align="center">
                                                    <input class="form-control" type="text" id="num_sol" value="" name="num_sol" disabled />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td align="center" class="fondoResaltado">
                                                    Fecha de Ingreso
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <input class="form-control" type="text" id="fecha_ingreso" value="" name="fecha_ingreso" disabled />
                                                </td>
                                            </tr>
                                        </tbody>

                                    </table>
                                </div>
                            </div>
                            <br />
                            <div>
                                <table class="tablaConBorde">
                                    <tr class="fondoResaltado">
                                        <td>CALLE O CAMINO</td>
                                        <td>N&Uacute;MERO</td>
                                    </tr>
                                    <tr>
                                        <td><input class="form-control" type="text" id="calle" name="calle" disabled [(ngModel)]="propiedad[0].calle" /></td>
                                        <td><input class="form-control" type="text" id="numero" name="numero" disabled [(ngModel)]="propiedad[0].calle_num" /></td>
                                    </tr>
                                </table>
                            </div>
                            <hr />
                            <br />
                            <br />
                            <br />
                            <br />
                            <br />
                        </div>
                    </div>
                </div>
            </div>
            <div>
                <button  mat-raised-button color="primary" id="pdf-download-link" title="Descargar Formulario 1.1" (click)="captureScreen()">Descargar Formulario 1.1</button>
            </div>
        </fieldset>
    </div>
</div>